import { Controller } from "react-hook-form";
import { Switch } from "../../../components/ui/switch";
import { Label } from "../../../components/ui/label";
import { FieldError } from "./FieldError";

function SwitchRow({ id, label, field }) {
  return (
    <div className="flex items-center justify-start gap-4 py-1">
      <Switch id={id} checked={!!field.value} onCheckedChange={field.onChange} />
      {label && <Label htmlFor={id} className="leading-snug">
        {label}
      </Label>}
    </div>
  );
}

export function SwitchInput({
  control,
  id,
  stepName,
  stepId,
  label,
  className="flex flex-col gap-3"
}) {
  return (
    <div className={className}>
      <Controller
        control={control}
        name={stepName}
        render={({ field }) => (
          <SwitchRow
            id={id}
            label={label}
            field={field}
          />
        )}
      />
      <FieldError name={stepName} step={stepId} />
    </div>
  )
}